import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPrimeComponent } from './simple-icons-prime.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPrimeComponent ],
    exports:      [ SimpleIconsPrimeComponent ],
    bootstrap:    []
})
export class SimpleIconsPrimeModule {}
